import React from 'react';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';
import { useLingui } from '@lingui/react/macro';
import { Project } from '@/types';
interface LinkToUnitChooseProjectProps {
    projects: Project[];
    value: number | null;
    onChange(projectId: number): void;
}

export const LinkToUnitChooseProject: React.FC<LinkToUnitChooseProjectProps> = ({ projects, value, onChange }) => {
    const { t } = useLingui();
    const productOptions = projects.map((p) => ({
        label: p.name,
        value: p.id,
    }));
    return (
        <Select
            fieldName={t`Project`}
            required
            options={productOptions}
            onChange={(nw: any) => onChange(nw.value)}
            value={productOptions.find((po) => po.value === value) || null}
            placeholder={t`Choose project`}
        />
    );
};
